module.exports = __webpack_public_path__ + "images/emoji/basketball.1105dc478e895fce9992.png";